module.exports = "<div ng-if=\"isHomeowners(wizard.model.policyChange.baseData.productCode)\"\r\n     gw-endorsement-ho-flow\r\n     wizard=\"wizard\"\r\n     flow=\"flow\"\r\n     is-state-visible=\"isStateVisible\">\r\n</div>\r\n<div ng-if=\"isPA(wizard.model.policyChange.baseData.productCode)\"\r\n     gw-endorsement-pa-flow\r\n     wizard=\"wizard\"\r\n     flow=\"flow\"\r\n     is-state-visible=\"isStateVisible\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/endorsement/directives/templates/endorsement-lob-flow.html
// module id = 1092
// module chunks = 0